import React from 'react'
import PetsList from '../pets-list'
const PetsPage = () => {
  return (
    <PetsList />
  );
};

export default PetsPage